const PRIMARY_COLOR = "#0161BF";
const SECONDARY_COLOR = "#DEEDFF";
const BG_COLOR = "#FFFFFF"

const lightTheme = {
  primaryColor: PRIMARY_COLOR,
  secondaryColor: SECONDARY_COLOR,
  backgroundColor: BG_COLOR,
  appbarColor: `linear-gradient(90deg, #0060BE 0%, #04AEED 100%)`,
  navbarColor: `linear-gradient(90deg, #0060BE 0%, #04AEED 100%)`,
  buttonColor: `linear-gradient(90deg, #0060BE 0%, #04AEED 100%)`,
  buttonHoverColor: `linear-gradient(90deg, #0060BE 0%, #04AEED 100%)`,
};

export default lightTheme;
